import React, { memo } from "react";

const PriceTextEnd = ({
  value,
  className,
  onClick,
  isCursorPointer = false,
  ...props
}) => {
  const style = { cursor: `${isCursorPointer ? "pointer" : ""}` };
  return (
    <div
      className={`text-end ${className} `}
      onClick={onClick}
      style={style}
      {...props}
    >
      {value}
    </div>
  );
};

export default memo(PriceTextEnd);
